import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=db51979c&scoped=true"
import script from "./CategoryNavigation.vue?vue&type=script&lang=ts"
export * from "./CategoryNavigation.vue?vue&type=script&lang=ts"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&id=db51979c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db51979c",
  null
  
)

export default component.exports